
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

// Simple guard that checks and asked the active component if it can leave

@Injectable()
export class ComponentCanDeactivateGuardService  {
    canDeactivate(component): Observable<boolean> | boolean {
        if (!component) {
            console.warn('ComponentCanDeactivateGuardService::: component === null');
            return true;
        } else {
            const canChange = typeof component.canDeactivate === 'function' ? component.canDeactivate() : true;
            if (typeof canChange === 'boolean') {
                if (!canChange) {
                    console.log('ComponentCanDeactivateGuardService::: Active component blocking navigation!');
                }
                return canChange;
            } else {
                return canChange; // Pass back the observable and wait for the user to confirm
            }
        }
    }
}
